document.addEventListener('click', function (e) {
  const target = /** @type {HTMLElement | null} */ (e.target instanceof HTMLElement ? e.target : null);
  if (!target) return;

  const removeButton = target.closest('.cart-items__remove');
  if (!removeButton) return;

  // Allow the theme's declarative `on:click` handler to run (it uses capture listeners),
  // then notify any free-shipping UI after the cart updates.
  setTimeout(() => {
    const freeShippingBar = document.querySelector('.cart-drawer__free-shipping');
    if (!freeShippingBar) return;

    document.dispatchEvent(new CustomEvent('cart:item-removed'));
  }, 100);
});

